//import CIPaper from "./components/CIPaper";
//import ProductButton from "./components/ProductButton";
//import CategoryBar from "./components/CategoryBar";
//import CartPanel from "./components/CartPanel";
//import DiscountDialog from "./components/DiscountDialog";
// import { Loading, Error } from "react-admin";
// import { Typography } from "@material-ui/core";
//import PaymentSelectCustomerType from "./pages/payment/payment-select-customer-type/";

import TierTriangleChart from "./pages/business-insight/Dashboard/Dashboard-Component/TierTriangleChart";

const Playground = () => {
  return (
    <>
      <TierTriangleChart />
    </>
  );
};

export default Playground;
